import type { PageResponseType, RequestPageParams, ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;
const prefix = '/api/v1';

export const userOrganizationApi = {
  /**
   * @description 获取组织列表
   */
  getList(params: RequestPageParams): PageResponseType<any[]> {
    return request({
      url: `${prefix}/admin/userOrganizations`,
      params: {
        ...params,
      },
    });
  },

  /**
   * @description 新增组织
   */
  add(data: any): ResponseType {
    return request({
      url: `${prefix}/admin/userOrganization`,
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取组织详情
   */
  getById(id: number): ResponseType<any> {
    return request({
      url: `${prefix}/admin/userOrganization/${id}`,
    });
  },

  /**
   * @description 更新组织
   */
  update(id: number, data: any): ResponseType {
    return request({
      url: `${prefix}/admin/userOrganization/${id}`,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除组织
   */
  del(id: number): ResponseType {
    return request({
      url: `${prefix}/admin/userOrganization/${id}`,
      method: 'DELETE',
    });
  },
};
